import { render, staticRenderFns } from "./HWConfigurations.vue?vue&type=template&id=d24f60d6&"
import script from "./HWConfigurations.vue?vue&type=script&lang=js&"
export * from "./HWConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports